import { defineRule } from 'vee-validate';

defineRule('valid-password', (value) => {
    let format = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[<>,.{}_+=#?!@$%^&*"£]).{6,}$');
    if (format.test(value)) {
        return true;
    }
    return 'Password should be longer than 8 characters, contain 1 uppercase, 1 lowercase, 1 numeric and 1 special character..';
});

